import PropTypes from 'prop-types';

export const flexBrandingDetailsType = PropTypes.shape({
    boxOutlineColour: PropTypes.string.isRequired,
    fontColour: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired
})